/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react'
import { Chip } from '@mui/material'
import { formatDate, formatMoney } from '../../utils/formatter'

function Delivery({ delivery }) {
  const {
    id, status, orderNo, createdOn, deliveryAmount, rider,
    distance,
  } = delivery
  return (
    <>
      <tr>
        <td style={{ padding: '15px' }}><h4>{id}</h4></td>
        <td><span>{orderNo}</span></td>
        <td><p>{formatDate(createdOn)}</p></td>
        <td><Chip label={status} /></td>
        <td><span>{distance}</span></td>
        <td><span>{formatMoney(deliveryAmount)}</span></td>
        <td><span>{rider ? `${rider.name}` : '--'}</span></td>
      </tr>
    </>
  )
}

export default function DeliveriesView({ deliveries }) {
  return (
    <div className="table-container">
      <table className="transactions-table">
        <thead>
          <tr>
            <th>Id</th>
            <th>Order No</th>
            <th>Created On</th>
            <th>Status</th>
            <th>Distance(Kms)</th>
            <th>Amount</th>
            <th style={{ minWidth: '100px' }}>Rider</th>
          </tr>
        </thead>
        <tbody>
          {deliveries.map((d) => <Delivery key={d.id} delivery={d} />)}
        </tbody>
      </table>
    </div>
  )
}
